import { Button, Divider, Flex } from "monday-ui-react-core";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { useCurrentMondayContext } from "@/components/AppContext/WithMondayContextAvailable";
import { GroupList } from "@/components/BacklogTable/GroupList";
import { clonePlusDialog } from "@/lib/monday";
import { MAX_ALLOWED_ITEMS } from "@/services/constant";
import { mondayService } from "@/services/monday-service";
import type { Board } from "@/types/common";
import { CheckOption } from "@/types/common";

import { SelectItemsLayout } from "./SelectItemsLayout";

const SelectItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  font-family: var(--font-family);
  padding-top: 35px;
  h5 {
    margin-bottom: 8px;
    padding-left: 0;
  }
`;

export default function SelectItems() {
  const [boardId, setBoardId] = useState<number>(-1);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [allBoardItemsFlag, setAllBoardItemsFlag] = useState<CheckOption>(CheckOption.NONE);
  const includedItems: string[] = [];
  const mondayContext = useCurrentMondayContext();
  const [boards, setBoards] = useState<Board[]>([]);

  useEffect(() => {
    void (async () => {
      const { boardId } = mondayContext;
      setBoardId(boardId);
      const board = await mondayService.getBoard(boardId);
      setBoards([board]);
    })()
      .then(() => {})
      .catch(() => {});
  }, [mondayContext]);

  useEffect(() => {
    const usageData = clonePlusDialog.getUsageDataFromParent();
    if (usageData) {
      const { boardId, selectedItems } = JSON.parse(usageData.dataJson) as { boardId: number; selectedItems: string[] };
      if (boardId !== -1) {
        setBoardId(boardId);
        setSelectedItems(selectedItems);
      }
    }
  }, []);

  const onSave = () => {
    clonePlusDialog.closeModalDialog({ dataJson: JSON.stringify({ boardId, selectedItems }) });
  };
  const onClose = () => {
    clonePlusDialog.closeModalDialog();
  };

  const toggleAllBoardItemsFlag = () => {
    const value =
      allBoardItemsFlag === CheckOption.NONE || allBoardItemsFlag === CheckOption.FALSE
        ? CheckOption.TRUE
        : CheckOption.FALSE;
    setAllBoardItemsFlag(value);
  };

  const getFooter = () => {
    return (
      <SelectItems.ButtonsWrapper>
        <Divider />
        <Flex gap={Flex.gaps.SMALL} justify={Flex.justify.END} style={{ width: "100%", paddingTop: "8px" }}>
          <Button disabled={selectedItems.length > MAX_ALLOWED_ITEMS} onClick={() => void onSave()}>
            Add item(s)
          </Button>
          <Button kind={Button.kinds.TERTIARY} onClick={() => void onClose()}>
            Close
          </Button>
        </Flex>
      </SelectItems.ButtonsWrapper>
    );
  };

  return (
    <SelectItemsLayout
      boards={boards}
      boardId={boardId}
      onAllBoardItemsFlagChange={toggleAllBoardItemsFlag}
      allBoardItemsFlag={allBoardItemsFlag}
    >
      <SelectItemsWrapper>
        <SelectItems.Items>
          <GroupList
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            allBoardItemsFlag={allBoardItemsFlag}
            setAllBoardItemsFlag={setAllBoardItemsFlag}
            includedItems={includedItems}
          />
        </SelectItems.Items>
        {getFooter()}
      </SelectItemsWrapper>
    </SelectItemsLayout>
  );
}

SelectItems.ButtonsWrapper = styled.div`
  padding: 0;
  padding-bottom: var(--spacing-large);
`;

SelectItems.Items = styled.div`
  flex-grow: 1;
  display: flex;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  ul {
    padding-left: 0;

    a {
      box-sizing: border-box;
    }
  }
`;
